export const testimonialsKeys = {
  all: ['testimonials'] as const,
  list: () => [...testimonialsKeys.all, 'list'] as const,
}
